<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl">
      <div class="text-container">
        <div class="title-area" v-show="launched != 1 && $store.state.currentsurvey_id != 0">
          <h1 class="page-title">
            <span>{{ screentexts[70]?screentexts[70].element_text:'Preview and launch' }}
            </span>
            <span
              class="ml-n1"
              :class="`${anon ? 'g-anon' : '' }`"
            >: {{ survey.survey_name }}
            </span>
          </h1>
        </div>
        <div v-show="$store.state.currentsurvey_id == 0">
          <h2>
            {{ screentexts[81]?screentexts[81].element_text:'No survey selected' }}
          </h2>
        </div>

        <div
          v-if="launched == 0 && $store.state.currentsurvey_id != 0"
        >
        <h3>
          {{ screentexts[71] ? screentexts[71].element_text : 'Survey Details' }}
        </h3>
        <div class="table-responsive d-table w-100 table-no-padding-first">
          <table class="table first-td-500 table-alternative">
            <tr>
              <td>
                {{ screentexts[72] ? screentexts[72].element_text : 'Survey name' }}
              </td>
              <td class="editable normal-input">
                <b-form-input
                  v-if="editable"
                  v-model="survey.survey_name"
                  :class="`${anon ? 'g-anon' : '' }`"
                />
                <span v-else :class="`${anon ? 'g-anon' : '' }`">
                  {{ survey.survey_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Survey type
              </td>
              <td class="editable select-column">
                <b-form-select
                  v-if="editable && false == true"
                  v-model="survey_type_id"
                  :options="surveytype_options"
                  @change="language_options_get(survey.surveytype_id);normvalues_countries_get();spotify_invoice_reference_get();"
                />
                <span v-else>
                  {{ surveytype_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[73] ? screentexts[73].element_text : 'Start date and time' }}
              </td>
              <td class="editable">
                <div>
                  <b-form-group
                    v-if="editable"
                    class="d-flex"
                    >
                      <datetime
                        id="start_date"
                        v-model="survey.survey_start_date"
                        type="date"
                        input-class="form-control"
                        format="yyyy-LL-dd"
                        :min-datetime="new Date().toISOString()"
                        :value="survey.survey_start_date"
                        value-zone="Europe/Stockholm"
                        zone="Europe/Stockholm"
                        :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                      />
                      <datetime
                        id="survey_start_time"
                        v-model="survey.survey_start_time"
                        type="time"
                        :value="survey.survey_start_time"
                        value-zone="Europe/Stockholm"
                        zone="Europe/Stockholm"
                        :minute-step="5"
                        input-class="form-control"
                        :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                        :title="screentexts[62]?screentexts[62].element_text:'Select sending time'"
                        @input="checkstartdate"
                      />
                  </b-form-group>
                  <span v-else>
                    {{ this.format_date(this.survey.survey_start_date) }} {{ this.format_time(this.survey.survey_start_time) }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[74] ? screentexts[74].element_text : 'End date and time' }}
              </td>
              <td class="editable">
                  <b-form-group
                    v-if="editable"
                    >
                      <datetime
                        id="end_date"
                        v-model="survey.survey_end_date"
                        type="date"
                        input-class="form-control"
                        format="yyyy-LL-dd"
                        :min-datetime="new Date().toISOString()"
                        :value="survey.survey_end_date"
                        value-zone="Europe/Stockholm"
                        zone="Europe/Stockholm"
                        :phrases="{ok: screentexts[60]?screentexts[60].element_text:'OK', cancel: screentexts[61]?screentexts[61].element_text:'Cancel'}"
                      />
                  </b-form-group>
                  <span v-else>
                    {{ this.format_date(survey.survey_end_date) }} 23:59
                  </span>
              </td>
            </tr>
            <tr>
              <td>
                {{ screentexts[75] ? screentexts[75].element_text : 'Language' }}
              </td>
              <td class="editable select-column">
                <b-form-select
                  v-if="editable"
                  v-model="survey_language_id"
                  :options="language_options"
                />
                <span v-else>
                  {{ language_name }}
                </span>
              </td>
            </tr>
            <tr v-if="survey.survey_type_id != 3">
              <td>
                {{ screentexts[76] ? screentexts[76].element_text : 'Norm data' }}
              </td>
              <td class="editable select-column">
                <b-form-select
                  v-if="editable"
                  v-model="survey_normvalues_id"
                  :options="norm_values_options"
                />
                <span v-else>
                  {{ normvalues_country_name }}
                </span>
              </td>
            </tr>
          </table>
        </div>

        <!-- <b-button
          variant="secondary"
          class="btn-small"
          @click="toggleEditable"
        >
          {{ editable ? 'Save' : 'Edit' }}
        </b-button> -->

          <h3 class="mt-5">
              <!-- fa-icon name="rocket" class="mr-2"/ -->{{ screentexts[79]?screentexts[79].element_text:'Survey Participants' }}
          </h3>
          <b-form-group>
            <b-button
            variant="secondary"
            id="add-new-member"
            class="my-2"
            @click="toggleAddMember"
            >
              Add new participant
            </b-button>
          </b-form-group>
          <b-form
            class="bg-secondary add-member-container"
            v-if="isAddMemberVisible"
            novalidate
            @submit.stop.prevent
          >
            <b-form-group
              class=""
            >
              <label class="">
                {{ screentexts[167]?screentexts[167].element_text:'Form Type' }}
              </label>
              <b-form-select
                v-model="groupmember_formoption_id"
                :options="formoptions"
              />
            </b-form-group>
            <b-form-group
              :state="groupmember_email_valid"
              v-show="groupmember_formoption_id==1"
              class=""
            >
              <label class="col-12 pl-0">
                {{ screentexts[164]?screentexts[164].element_text:'Email address' }}
              </label>
              <input
                v-model="groupmember_email"
                class="form-control col-12"
                :class="`${anon ? 'g-anon' : '' }`"
                :state="groupmember_email_valid"
                type="text"
                :placeholder="screentexts[170]?screentexts[170].element_text:'Email Address'"
              >
              <span
                v-show="groupmember_email_valid == 'invalid'"
                class="text-danger"
              >Invalid or duplicate email address</span>
              <span v-show="groupmember_email_valid != 'invalid'">&nbsp;</span>
            </b-form-group>
            <b-form-group
              class="mb-0"
            >
              <div class="text-right">
                <b-button
                  variant="primary"
                  @click.prevent="addgroupmember"
                >
                  <span class="d-inline-block d-md-none d-lg-inline-block">{{ screentexts[175]?screentexts[175].element_text:'Add' }}</span>
                </b-button>
                <b-button
                  variant="danger"
                  class="ml-2"
                  @click="toggleAddMember"
                >
                  <span class="d-inline-block d-md-none d-lg-inline-block">Cancel</span>
                </b-button>
              </div>
            </b-form-group>
          </b-form>
          <b-table
            :fields="fields"
            :class="'actions-table save-cancel'"
            :items="includedGroupMembers"
            :tbody-tr-class="rowClass"
          >
          <template v-slot:cell(actions)="data">
            <div class="d-flex justify-content-end">
              <!-- <div v-if="data.item.editable">
                <b-button variant="danger" class="btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
                <b-button variant="primary" class="btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</b-button>
              </div> -->
              <b-dropdown right class="ml-2">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click.prevent="togglegroupmember(data.item.id)">Exclude from this survey</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <template v-slot:cell(groupmember_code)="data">
            {{ data.item.groupmember_code }}
          </template>

          <template v-slot:cell(groupmember_email)="data">
            <div class="position-relative">
              <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
              <b-form-input
                  v-else
                  v-model="data.item.groupmember_email"
                  type="text"
                  :class="{'g-anon': anon, 'text-danger': data.item.groupmember_email_valid == 'invalid'}"
                />
                <i
                  v-if="data.item.groupmember_email_valid == 'invalid' && data.item.editable"
                  class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                  v-b-tooltip="'Invalid email address'"
                ></i>
            </div>
          </template>
          <template v-slot:cell(groupmember_mobile)="data">
            <b-form-input
              v-model="data.item.groupmember_mobile"
              type="text"
            />
          </template>

          <template v-slot:cell(groupsurveymember_formoption_id)="data">
            <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
            <b-form-select v-else v-model="data.item.groupsurveymember_formoption_id" :options="formoptions" />
          </template>

        </b-table>

        <h3 class="mt-5 mb-3">
          Members not included in this survey
        </h3>

        <b-table
          :fields="fields"
          :class="'actions-table save-cancel excluded mb-5'"
          :items="excludedGroupMembers"
          :tbody-tr-class="rowClass"
        >
          <template v-slot:cell(actions)="data">
            <div class="d-flex justify-content-end">
              <div v-if="data.item.editable">
                <b-button variant="danger" class="btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
                <b-button variant="primary" class="btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</b-button>
              </div>
              <b-dropdown right class="ml-2">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click.prevent="togglegroupmember(data.item.id)">Include in this survey</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <template v-slot:cell(groupmember_code)="data">
            {{ data.item.groupmember_code }}
          </template>

          <template v-slot:cell(groupmember_email)="data">
            <div>
              <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
              <b-form-input v-else v-model="data.item.groupmember_email" type="text"
                :class="{ 'g-anon': anon }"
              />
            </div>
          </template>
          <template v-slot:cell(groupmember_mobile)="data">
            <b-form-input
              v-model="data.item.groupmember_mobile"
              type="text"
            />
          </template>

          <template v-slot:cell(groupsurveymember_formoption_id)="data">
            <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
            <b-form-select v-else v-model="data.item.groupsurveymember_formoption_id" :options="formoptions" />
          </template>
        </b-table>
        </div>
        <b-row class="mt-3 mb-5">
          <div
            v-show="$store.state.currentsurvey_id != 0"
            class="col-12"
          >

            <div v-show="launched == 0" class="d-flex justify-content-between">
                <b-link
                  v-show="launched == 0"
                  to="/create/group/survey/dates"
                  class=""
                >
                  <b-button variant="secondary">
                    &lt; Back
                  </b-button>
                </b-link>
                <b-button
                  v-show="launched == 0"
                  variant="primary"
                  class="btn-lg align-self-right"
                  @click="groupsurvey_launch"
                >
                  {{ !isscheduled()?screentexts[80]?screentexts[80].element_text:'Everything looks good. Launch the survey!':'Everything looks good. Schedule the survey' }}
                </b-button>
            </div>
            <p class="text-left text-lg" v-show="launched == 3">
              {{ screentexts[85]?screentexts[85].element_text:'Your survey has been launched!' }}
            </p>
            <p class="text-left text-lg" v-show="launched == 2">
              Your survey has been scheduled for launch on {{ survey.survey_start_date }} at {{ survey.survey_start_time }}
            </p>
            <div
              v-if="has_paper==1 && launched>1"
              class="d-none d-md-inline-block text-lg"
            >
              {{ screentexts[86]?screentexts[86].element_text:'This survey has paper forms, you can choose to print these now,' }}
              <br>
              {{ screentexts[87]?screentexts[87].element_text:'or print them at a later time from the Survey Page.' }}
              <br>&nbsp;
              <br>&nbsp;
              <b-button
                class="btn-lg text-left pt-2"
                variant="success"
                @click.prevent="print_paperforms"
              >
                <span class="icon-printer mr-2" />Print the Paper Forms now
              </b-button>
            </div>
            <b-link
              v-if="launched == 2 || launched == 3"
              to="/"
              style="text-decoration: none;"
              class="mt-5 d-block text-right"
            >
              <b-button
                  variant="primary"
                  class="btn-lg align-self-right"
                >
                {{ screentexts[88]?screentexts[88].element_text:'Return to My GDQ Management' }}
              </b-button>
            </b-link>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { config } from '../../config'
import PopupBubble from './PopupBubble.vue'
import { Datetime } from 'vue-datetime'

export default {
  name: 'CreateGroupSurveyLaunch',
  components: {
    Navbar,
    Breadcrumb,
    Datetime
    // PopupBubble,
  },
  data () {
    return {
      isAddMemberVisible: false,
      survey: this.$store.state.currentsurvey,
      group_name: this.$store.state.currentgroup.group_name,
      languages: this.$store.state.languages,
      normvalues_countries: this.$store.state.normvalues_countries,
      fields: [
        { key: 'groupmember_code', label: 'Member', tdClass: 'd-none d-sm-table-cell', thClass: 'd-none d-sm-table-cell' },
        { key: 'groupmember_email', label: 'Email', class: 'editable email-column' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', class: 'editable select-column' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      survey_type_id: this.$store.state.currentsurvey.survey_type_id,
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      surveytype_name: 'GDQ',
      launched: 0,
      has_mail: 0,
      has_paper: 0,
      screen_id: 9,
      screentexts: [],
      currentsurveymembers: [],
      groupmembers_grid: [],
      nextid: 10000000,
      original_member_data: {}, // To store the original data before editing
      editable: false,
      profile: this.$store.state.profile,
      spotify: this.$store.state.currentsurvey.spotify,
      survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
      norm_values_options: [],
      language_options: [],
      surveytype_options: [],
      survey_language_id: this.$store.state.currentsurvey.survey_language_id,
      serverdate: this.serverdate_get(),
      loading: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    formoptions: {
      get () {
        var items = this.$store.state.formoptions
        var formoptions = []
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].formoption_name
          }
          formoptions.push(option)
        }
        return formoptions
      }
    },
    surveystartdate: {
      get () {
        return this.$store.state.currentsurvey.survey_start_date
      },
      set () {
        return true
      }
    },
    surveymembers () {
      var currentgroupmembers = this.$store.state.currentgroupmembers
      return currentgroupmembers.map(member => ({
        ...member,
        editable: false // Add the editable state to each group member
      }))
    },
    surveymembers: {
      get () {
        const groupmembers_db = []
        const currentsurveymembers = this.$store.state.currentsurveymembers
        const currentgroupmembers = this.$store.state.currentgroupmembers

        for (let i = 0; i < currentsurveymembers.length; i++) {
          const surveymember = currentsurveymembers[i]

          let groupmember = currentgroupmembers.find(gm => gm.id === surveymember.groupmember_id)

          if (groupmember) {
            groupmember.groupsurveymember_formoption_id = surveymember.groupsurveymember_formoption_id
            groupmember.newid = surveymember.id
            groupmember.included_in_survey = surveymember.included_in_survey
            groupmember.editable = surveymember.editable
            groupmembers_db.push(groupmember)
          }
        }
        return groupmembers_db
      }
    },
    includedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey == 1)
    },

    excludedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey == 0)
    },
    reminder: {
      get () {
        if (this.$store.state.currentsurvey.survey_reminder == 1) {
          return 'Yes'
        } else {
          return 'No'
        }
      },
      set () {
        return true
      }
    },
    remindparticipants: {
      get () {
        if (this.$store.state.currentsurvey.survey_remindparticipants == 1) {
          return 'Yes'
        } else {
          return 'No'
        }
      },
      set () {
        return true
      }
    },
    language_name: {
      get () {
        const langid = this.survey_language_id
        var language_name = ''
        for (var i = 0; i < this.languages.length; i++) {
          if (this.languages[i].id == langid) {
            language_name = this.languages[i].language_name
          }
        }
        // var language_name = this.languages[this.$store.state.currentsurvey.survey_language_id];
        return language_name
      },
      set () {
        return true
      }
    },
    normvalues_country_name: {
      get () {
        var normvalues_country_name = ''
        for (var i = 0; i < this.normvalues_countries.length; i++) {
          if (this.normvalues_countries[i].country_id == this.survey_normvalues_id) {
            normvalues_country_name = this.normvalues_countries[i].country_name
          }
        }
        return normvalues_country_name
      },
      set () {
        return true
      }
    }
  },
  watch: {
    addingsurveymember: function () {
      this.survey_get()
    },
    surveymembers () {
      this.groupmembers_grid = this.surveymembers.map(member => ({
        ...member,
        editable: false // Ensure to set editable state when data changes
      }))
    }
  },
  async created () {
    await this.profile_get()
    await this.languages_get()
    await this.screentexts_get()
    await this.survey_get()
    // console.log(this.survey)
    await this.surveytype_get()
    await this.formoptions_get()
    await this.normvalues_countries_get()
    await this.language_options_get(this.survey_type_id)
    await this.spotify_invoice_reference_get()
  },
  beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    // if (to.path == '/') {
    //   this.groupsurvey_launch();
    // }
    next()
  },
  methods: {
    serverdate_get: async function () {
      await this.$store.dispatch('serverdate_fetch')
        .then((resp) => {
        // console.log('serverdate_get', resp.data);
          this.serverdate = resp.data
          return resp.data
        })
    },
    toggleEditable () {
      this.editable = !this.editable
      const rows = document.querySelectorAll('.table-alternative tr')
      rows.forEach(row => {
        if (this.editable) {
          row.classList.add('editable-row')
        } else {
          row.classList.remove('editable-row')
          this.surveytype_get()
        }
      })
    },
    rowClass (item, index) {
      return item.editable ? 'editable-row' : ''
    },
    formoptions_get: async function () {
      await this.$store.dispatch('formoptions_fetch')
    },
    toggleAddMember () {
      this.isAddMemberVisible = !this.isAddMemberVisible
    },
    getFormOptionText (id) {
      const option = this.formoptions.find(option => option.value === id)
      return option ? option.text : ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_grid[index].groupmember_code = this.original_member_data[id].groupmember_code
        this.groupmembers_grid[index].groupmember_email = this.original_member_data[id].groupmember_email
        this.groupmembers_grid[index].groupmember_mobile = this.original_member_data[id].groupmember_mobile
        this.groupmembers_grid[index].groupmember_formoption_id = this.original_member_data[id].groupmember_formoption_id
        this.groupmembers_grid[index].groupsurveymember_formoption_id = this.original_member_data[id].groupsurveymember_formoption_id
        this.groupmembers_grid[index].groupmember_status_id = this.original_member_data[id].groupmember_status_id
        this.groupmembers_grid[index].included_in_survey = this.original_member_data[id].included_in_survey
        this.groupmembers_grid[index].editable = false
        delete this.original_member_data[id]
      }
    },

    saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        if (this.validateEditedMember(member)) {
          member.editable = false
          delete this.original_member_data[id]
          this.updatesurvey(false)
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },

    validateEditedMember (member) {
      if (member.groupsurveymember_formoption_id != 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      } else {
        return this.parse_email(member.groupmember_email)
      }
    },

    async languages_get () {
      await this.$store.dispatch('languages_fetch')
        .then((res) => {
          this.languages = res.data.result
        })
    },

    async language_options_get (survey_type_id) {
      var filter = {}
      if (this.spotify === '1' && survey_type_id == 2) {
        this.language_options = []
        this.language_options.push({
          value: 38,
          text: 'English'
        })
        this.survey_language_id = 38
        return true
      }
      switch (survey_type_id) {
        case '1':
          filter['language_enabled'] = {
            operator: '=',
            value: '1'
          }
          break
        case '2':
          filter['language_enabled_gdq_short'] = {
            operator: '=',
            value: '1'
          }
          break
        case '3':
          filter['language_enabled_osc'] = {
            operator: '=',
            value: '1'
          }
          break
        default:
          filter['language_enabled'] = {
            operator: '=',
            value: '1'
          }
      }
      await this.$store.dispatch('records_readall', { table_name: 'g_languages', filter: filter, orderby: 'language_name' })
        .then((resp) => {
          this.language_options = []
          for (var i = 0; i < resp.data.result.length; i++) {
            this.language_options.push({
              value: resp.data.result[i].id,
              text: resp.data.result[i].language_name
            })
          }
        })
      return true
    },
    async spotify_invoice_reference_get () {
      if (this.profile.spotify == 1) {
        if (this.spotify == 1 && this.survey_type_id == 2) {
          await this.$store.dispatch('syspref_get', { name: 'spotify_invoice_reference' })
            .then((resp) => {
              this.survey_invoice_reference = resp.data.value
            })
        } else {
          this.survey_invoice_reference = ''
        }
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    screentexts_get: async function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    print_paperforms () {
      this.$store.dispatch('paperforms_fetch', { survey_id: this.$store.state.currentsurvey_id })
        .then((resp) => {
          var paperformsurl = config.report_url + '/gdq_paperforms.php?i=' + resp.data.id
          window.open(paperformsurl)
        })
    },
    async surveytype_get () {
      await this.$store.dispatch('record_read', { table_name: 'g_surveytypes', id: this.survey_type_id })
        .then((resp) => {
          this.surveytype_name = resp.data.surveytype_name
        })
    },
    survey_get: async function () {
      this.has_paper = 0
      this.has_mail = 0
      await this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id }).then((resp) => {
        this.survey = resp.data
        this.$store.dispatch('groupsurveymembers_fetch', { survey_id: this.survey.id })
          .then((resp) => {
            var members = resp.data.result
            this.currentsurveymembers = members
            for (var i = 0; i < members.length; i++) {
              if (members[i].groupsurveymember_formoption_id === 1) { this.has_mail = 1 }
              if (members[i].groupsurveymember_formoption_id === 2) { this.has_paper = 1 }
              members[i].editable = false
            }
          // if (this.survey.survey_status_id == 1) {
          //   var data = {
          //     id: this.$store.state.currentsurvey.id,
          //     survey_status_id: 2
          //   }
          //   this.$store.dispatch('groupsurvey_save', { survey: data })
          //     .then(() => {
          //       this.$store.dispatch('groupsurvey_fetch', { id: this.survey.id }).then((resp) => {
          //         this.survey = resp.data;
          //       })
          //     })
          // }
          })
      })
    },
    togglegroupmember (id) {
      for (var i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id == id) {
          if (this.groupmembers_grid[i].included_in_survey == 1) {
            this.groupmembers_grid[i].included_in_survey = 0
          } else {
            this.groupmembers_grid[i].included_in_survey = 1
          }
          this.updatesurvey(false)
        }
      }
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
    },
    validategroupmember () {
      var formok = true
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (this.groupmember_formoption_id == 1) {
        if (this.groupmember_email == '') {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
        // eslint-disable-next-line
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.groupmember_email) == false) {
        if (!this.parse_email(this.groupmember_email)) {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
      }
      return formok
    },
    profile_get: async function () {
      await this.$store.dispatch('profile_fetch')
        .then((resp) => {
          this.profile = resp.data
          this.$store.dispatch('surveytypes_fetch')
            .then((resp) => {
              var items = resp.data.result
              var options = []
              for (var i = 0; i < items.length; i++) {
                var option = {
                  value: items[i].id,
                  text: items[i].surveytype_name
                }
                options.push(option)
              }
              this.surveytype_options = options
            })
        })
      if (this.profile.spotify === '1') { this.spotify = '1' }
    },
    normvalues_countries_get: async function () {
      let survey_type_id = this.survey_type_id
      await this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          var options = []
          for (var i = 0; i < resp.data.length; i++) {
            if (resp.data[i].country_id == 999 || survey_type_id == 1) {
              var option = {
                value: resp.data[i].country_id,
                text: resp.data[i].country_name
              }
              options.push(option)
            }
          }
          this.norm_values_options = options
        })
    },
    updatesurvey (adding) {
      var newmember = {
        id: this.nextid, // id
        groupmember_code: '', // groupmember_code
        groupmember_name: this.groupmember_name,
        groupmember_email: this.groupmember_email,
        groupmember_mobile: this.groupmember_mobile,
        groupmember_formoption_id: this.groupmember_formoption_id,
        groupsurveymember_formoption_id: this.groupmember_formoption_id,
        groupmember_status_id: 0,
        included_in_survey: true,
        newid: 0,
        _rowVariant: 'success'
      }
      if (newmember != null && adding) {
        this.nextid++
        this.cleargroupmember()
        this.groupmembers_grid.push(newmember)
        var data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('addingsurveymember_set', {
          addingsurveymember: true
        })
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          this.survey_get()
        })
      } else {
        var data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          this.survey_get()
        })
      }
    },
    addgroupmember () {
      if (this.validategroupmember()) {
        this.updatesurvey(true)
      }
    },
    async groupsurvey_save () {
      var survey = {
        id: this.$store.state.currentsurvey_id,
        survey_name: this.survey.survey_name,
        survey_language_id: this.survey_language_id,
        survey_normvalues_id: this.survey_normvalues_id,
        survey_type_id: this.survey_type_id,
        survey_invoice_reference: this.survey_invoice_reference,
        survey_start_date: this.format_date(this.survey.survey_start_date),
        survey_end_date: this.format_date(this.survey.survey_end_date),
        survey_start_time: this.format_time(this.survey.survey_start_time),
        survey_reminder_date: this.survey.survey_reminder_date,
        survey_reminder_email: this.survey.survey_reminder_email,
        survey_reminder_mobile: this.survey.survey_reminder_mobile,
        survey_reminder: this.survey.survey_reminder,
        survey_status_id: this.survey.survey_status_id,
        spotify: this.profile.spotify === '1' && this.survey_type_id === '2' && this.spotify === '1' ? '1' : '0'
      }
      await this.$store.dispatch('groupsurvey_save', { survey: survey })
        .then(async (resp) => {
          this.survey_id = resp.data.id
          const data = {
            survey_id: this.survey_id,
            survey_language_id: this.survey_language_id,
            survey_type_id: this.survey.survey_type_id
          }
          await this.$store.dispatch('groupsurvey_changelanguage', data)
            .then(async (resp) => {
              this.survey_invitation_text = resp.data.survey_invitation_text
              this.survey_invitation_subject = resp.data.survey_invitation_subject
              this.survey_get()
              await this.$store.dispatch('groupsurvey_setcurrent', { survey_id: this.survey_id })
              return true
            })
        })
    },
    async groupsurvey_launch () {
      this.launched = 1
      await this.groupsurvey_save()
        .then(() => {
          if (this.isscheduled()) {
            this.survey.survey_status_id = 2
            this.groupsurvey_save()
            this.launched = 2
          } else {
            var mailmembers = []
            for (var i = 0; i < this.$store.state.currentsurveymembers.length; i++) {
              if (this.$store.state.currentsurveymembers[i].groupsurveymember_formoption_id == 1) {
                mailmembers.push(this.$store.state.currentsurveymembers[i])
              }
            }
            var payload = {
              survey: this.survey,
              surveymembers: mailmembers,
              mail_subject: this.$store.state.currentsurvey.survey_invitation_subject,
              mail_text: this.$store.state.currentsurvey.survey_invitation_text,
              mail_consultant_text: this.$store.state.currentsurvey.survey_invitation_consultant_text,
              mail_cc: this.$store.state.currentsurvey.survey_invitation_cc,
              mail_type: 'Invitation'
            }
            this.$store.dispatch('groupsurvey_mail', payload)
            this.launched = 3
            this.launch_done()
          }
        })
    },
    async launch_done () {
      this.survey.survey_status_id = 3
      await this.groupsurvey_save()
      this.launched = 3
    },
    format_date (date) {
      const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}([+-]\d{2}:\d{2}|Z)$/
      if (typeof date === 'string' && isoDatePattern.test(date)) {
        var d = new Date(date)
        var month = '' + (d.getMonth() + 1)
        var day = '' + d.getDate()
        var year = d.getFullYear()
        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day
        return [year, month, day].join('-')
      } else {
        return date
      }
    },
    format_time (date) {
      const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}([+-]\d{2}:\d{2}|Z)$/
      if (typeof date === 'string' && isoDatePattern.test(date)) {
        var d = new Date(date)
        var h = d.getHours()
        var m = d.getMinutes()
        var hour = (h > 9 ? '' : '0') + h
        var minute = (m > 9 ? '' : '0') + m
        var thistime = hour + ':' + minute
        return thistime
      } else {
        return date
      }
    },
    default_end_date () {
      var date = new Date(this.serverdate)
      date = this.add_months(date, 3)
      return date.toISOString()
    },
    default_reminder_date () {
      var date = new Date(this.serverdate)
      date.setDate(date.getDate() + 87)
      return date.toISOString()
    },
    add_months (date, count) {
      if (date && count) {
        var m; var d = (date = new Date(+date)).getDate()
        date.setMonth(date.getMonth() + count, 1)
        m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    checkstartdate (event) {
      if (this.loading == true) { return true }
      this.showtimeadjust = false
      const startvalue = this.survey.survey_start_date.substring(0, 10) + 'T' + this.survey.survey_start_time.substr(this.survey.survey_start_time.indexOf('T') + 1)
      const startvaluetz = new Date((typeof startvalue === 'string' ? new Date(startvalue) : startvalue).toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' }))
      const nowdate = this.serverdate
      if (startvaluetz < nowdate) {
        this.showtimeadjust = true
      }
    },
    isscheduled () {
      const today = this.serverdate
      const surveydate = this.format_date(this.survey.survey_start_date) + ' ' + this.format_time(this.survey.survey_start_time) + ':00'

      if (surveydate.toString() > today.toString()) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
</style>
